import React from 'react';
import { makeFirstLetterCapital } from '../../helpers/utils';

export const BasicDetailItem = ({
  label,
  value,
  direction = 'horizontal',
  dataClassName,
  isBold,
  makeFirstCharCapital = true,
  style,
}) => (
  <div className={`basic-detail-item ${direction} mb-2`}>
    {label ? <div className='basic-detail-label'>{label}: </div> : null}
    <div
      className={`${dataClassName ?? ''} basic-detail-data`}
      style={{
        fontFamily: isBold ? 'Brown Bold' : 'Brown',
        fontWeight: 400,
        ...style,
      }}
    >
      {makeFirstCharCapital ? makeFirstLetterCapital(value) : value}
    </div>
  </div>
);
